import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import type { Rdo } from "../../types.ts";

interface CrewSectionProps {
	rdo: Rdo;
	readOnly: boolean;
	onChange: (enabled: boolean) => void;
}

export function CrewSection({ rdo, readOnly, onChange }: CrewSectionProps) {
	return (
		<section className="rdo-editor__section" aria-labelledby="rdo-crew">
			<h2 id="rdo-crew" className="rdo-editor__section-title">
				Anexo de equipe
			</h2>
			<div className="rdo-editor__toggle">
				<Switch
					id="rdo-crew-annex"
					checked={rdo.crewAnnexEnabled}
					disabled={readOnly}
					onCheckedChange={onChange}
				/>
				<div>
					<Label htmlFor="rdo-crew-annex">Incluir a presença da equipe</Label>
					<p className="rdo-editor__hint">
						Adiciona ao PDF uma página com as entradas e saídas registradas no
						ponto na data do relatório.
					</p>
				</div>
			</div>
		</section>
	);
}
